import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading, Beam } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

export const FaqSection = () => {
  const { content } = useContent();
  const faqs = content.faqs || [];

  return (
    <section id="faq" data-testid="faq-section" className="relative overflow-hidden py-20 lg:py-32 bg-surface border-y border-gold/10">
      <Beam />
      <div className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto">
        <SectionHeading overline="Frequently Asked Questions" title="Answers Before You Hit the Road." center testId="faq-heading" tag="Hit the Road!" />
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="card-gold border border-gold/15 px-6 data-[state=open]:border-gold/50"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-lg sm:text-xl uppercase tracking-wide text-white hover:text-champagne hover:no-underline py-5"
                >
                  {f.question}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm text-zinc-400 leading-relaxed pb-6">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
